import { call, put, take, takeEvery } from 'redux-saga/effects';

import {
    FETCH_INTENSITY_MINUTES_DATA,
    FETCH_INTENSITY_MINUTES_DATA_FETCHING,
    FETCH_INTENSITY_MINUTES_DATA_SUCCESS,
    FETCH_INTENSITY_MINUTES_DATA_FAIL,
    FETCH_INTENSITY_MINUTES_DAILY_DATA,
    FETCH_INTENSITY_MINUTES_DAILY_DATA_FETCHING,
    FETCH_INTENSITY_MINUTES_DAILY_DATA_SUCCESS,
    FETCH_INTENSITY_MINUTES_DAILY_DATA_FAIL,
    FETCH_INTENSITY_MINUTES_WEEKLY_DATA,
    FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FETCHING,
    FETCH_INTENSITY_MINUTES_WEEKLY_DATA_SUCCESS,
    FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FAIL,
    FETCH_INTENSITY_MINUTES_HOURLY_DATA,
    FETCH_INTENSITY_MINUTES_HOURLY_DATA_DONE
} from '../actions/ActionTypes';
import { gcApi } from '../config/axios';

export function* fetchIntensityMinutesSaga(action) {
    const { calendarDate } = action.payload;

    try {
        yield put({
            type: FETCH_INTENSITY_MINUTES_DATA_FETCHING
        });

        const response = yield call(gcApi.get, `/wellness-service/wellness/daily/im/${calendarDate}`);

        yield put({
            type: FETCH_INTENSITY_MINUTES_DATA_SUCCESS,
            intensityMinutesData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_INTENSITY_MINUTES_DATA_FAIL,
            intensityMinutesData: null
        });
    }
}

export function* fetchIntensityMinutesDailyData(action) {
    const { fromDate, untilDate } = action.payload;

    try {
        yield put({
            type: FETCH_INTENSITY_MINUTES_DAILY_DATA_FETCHING
        });

        const response = yield call(gcApi.get, `usersummary-service/stats/im/daily/${fromDate}/${untilDate}`);

        yield put({
            type: FETCH_INTENSITY_MINUTES_DAILY_DATA_SUCCESS,
            intensityMinutesDailyData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_INTENSITY_MINUTES_DAILY_DATA_FAIL,
            intensityMinutesDailyData: null
        });
    }
}

export function* fetchIntensityMinutesWeeklyData(action) {
    const { fromDate, untilDate } = action.payload;

    try {
        yield put({
            type: FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FETCHING
        });

        const response = yield call(gcApi.get, `usersummary-service/stats/im/weekly/${fromDate}/${untilDate}`);

        yield put({
            type: FETCH_INTENSITY_MINUTES_WEEKLY_DATA_SUCCESS,
            intensityMinutesWeeklyData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FAIL,
            intensityMinutesWeeklyData: null
        });
    }
}

export function* fetchIntensityMinutesHourlyDataSaga(action) {
    const { endDate, numDays } = action;

    try {
        const response = yield call(gcApi.get, `/wellness-service/stats/hourly/im/${endDate}/${numDays}`);

        yield put({
            type: FETCH_INTENSITY_MINUTES_HOURLY_DATA_DONE,
            error: false,
            intensityMinutesHourlyData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_INTENSITY_MINUTES_HOURLY_DATA_DONE,
            error: true,
            intensityMinutesHourlyData: null
        });
    }
}

export const intensityMinutesSagas = [
    takeEvery(FETCH_INTENSITY_MINUTES_DATA, fetchIntensityMinutesSaga),
    takeEvery(FETCH_INTENSITY_MINUTES_DAILY_DATA, fetchIntensityMinutesDailyData),
    takeEvery(FETCH_INTENSITY_MINUTES_WEEKLY_DATA, fetchIntensityMinutesWeeklyData),
    takeEvery(FETCH_INTENSITY_MINUTES_HOURLY_DATA, fetchIntensityMinutesHourlyDataSaga)
];
